export const GoogleAPI = "AIzaSyC4HiN2rOWVNMwzzcM5LZZxlMNkUjZsFRA";
